// extracted by mini-css-extract-plugin
export var $animation_name = "Page-module--$animation_name--04f17";
export var Page = "Page-module--Page--55822";
export var Page___christmas = "Page-module--Page___christmas--9bc12";